import { DateFormatOptions } from './types';

export const convertDate = (dateStr: string) => {
    const date = new Date(dateStr);

    const day = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });

    const time = date.toLocaleTimeString('en-US', {
        hour12: true,
        hour: '2-digit',
        minute: '2-digit',
    });

    return {
        day: day === 'Invalid Date' ? '' : day,
        time: time === 'Invalid Date' ? '' : time,
    };
};

export const isToday = (date: string) => {
    const today = new Date();
    const currentDate = new Date(date);

    if (!currentDate) {
        return false;
    }

    return (
        currentDate.getDate() == today.getDate() &&
        currentDate.getMonth() == today.getMonth() &&
        currentDate.getFullYear() == today.getFullYear()
    );
};

export const convertFormatDateForReportsRequest = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const convertReadableFormatDate = (
    date: Date | string | undefined,
    options?: DateFormatOptions,
): string => {
    if (!date) return '';

    try {
        const dateObj = date instanceof Date ? date : new Date(date);

        if (Number.isNaN(dateObj.getTime())) {
            return '';
        }

        const locale = options?.locale || 'en-US';
        const formatOptions: Intl.DateTimeFormatOptions = {
            year: options?.year || 'numeric',
            month: options?.month || 'short',
            day: options?.day || '2-digit',
            timeZone: options?.timeZone ?? 'UTC',
        };

        return dateObj.toLocaleDateString(locale, formatOptions);
    } catch {
        return '';
    }
};
